import cls from "classnames"
import React, { FC, ReactNode } from "react"

import { sfxPlay } from "@/assets/audios/sfx"
import OutlinedText from "../OutlinedText"

import styles from "./index.module.scss"

const Button: FC<{
    type?:
        | "primary"
        | "secondary"
        | "normal"
        | "submit"
        | "cancel"
        | "paging"
        | "subPaging"
    size?: "large" | "normal" | "small" | "formBtn" | "paging" | "shareBtn"
    className: string
    onClick?: () => void
    disabled?: boolean
    text: ReactNode
    outlinedText?: string
    outlineStyle?: Object
}> = ({
    className,
    text,
    outlinedText,
    onClick,
    disabled,
    type = "primary",
    size = "large",
    outlineStyle = {},
}) => {
    return (
        <div
            className={cls(
                styles.button,
                className,
                styles[type],
                styles[`${size}Size`],
                disabled ? styles.disabled : null,
            )}
            onClick={() => {
                onClick?.()
                sfxPlay("click")
            }}
        >
            {outlinedText ? (
                <OutlinedText
                    className={styles.outlinedText}
                    text={outlinedText}
                    strokeColor="#714e2f"
                    strokeWidth={8}
                    fillColor="#f7f5db"
                    fontSize={62}
                    {...outlineStyle}
                />
            ) : (
                <div className={styles.text}>{text}</div>
            )}
            {/* <div className={styles.inner}>{text}</div> */}
        </div>
    )
}

export default Button
